import { dict } from '@contember/bindx-ui'

/**
 * Czech strings for the bindx-ui widgets. The library ships English ones, and
 * whatever is left untranslated surfaces in the middle of a Czech screen —
 * „2 rows" under a table of kurzy, „Yes"/„No" in a boolean cell.
 *
 * `dict` is a plain exported object — bindx-ui has no dictionary provider, so
 * assignment at boot (before the first render) is the intended override.
 *
 * Counts avoid Czech plural agreement on purpose. The library interpolates a
 * fixed template, so there is no place to pick between „řádek", „řádky" and
 * „řádků"; a label with a colon is correct for every number.
 */
export function applyCzechDict(): void {
	dict.errors.required = 'Povinné pole'
	dict.errors.unique = 'Tahle hodnota už je obsazená'
	dict.errors.unknown = 'Něco se nepovedlo'

	dict.input.noValue = 'Nevyplněno'

	dict.repeater.empty = 'Zatím nic.'
	dict.repeater.addItem = 'Přidat položku'

	dict.blockRepeater.addBlock = 'Přidat blok'
	dict.blockRepeater.close = 'Zavřít'
	dict.blockRepeater.delete = 'Smazat'

	dict.uploader.uploadErrors.httpError = 'Chyba serveru'
	dict.uploader.uploadErrors.aborted = 'Nahrávání zrušeno'
	dict.uploader.uploadErrors.networkError = 'Chyba sítě'
	dict.uploader.uploadErrors.timeout = 'Nahrávání vypršelo'
	dict.uploader.uploadErrors.fileRejected = 'Soubor odmítnut'
	dict.uploader.unknownError = 'Neznámá chyba'
	dict.uploader.browseFiles = 'Vybrat soubor'
	dict.uploader.dropFiles = 'Přetáhni sem soubory'
	dict.uploader.or = 'nebo'
	dict.uploader.done = 'Hotovo'

	dict.boolean.true = 'Ano'
	dict.boolean.false = 'Ne'

	dict.persist.save = 'Uložit'

	dict.toast.persistSuccess = 'Změny uloženy'
	dict.toast.persistError = 'Změny se nepodařilo uložit'
	dict.toast.persistValidationError = 'Než uložíš, oprav prosím chyby ve formuláři'
	dict.toast.loadError = 'Data se nepodařilo načíst'
	dict.toast.networkError = 'Chyba sítě'
	dict.toast.dismiss = 'Zavřít'
	dict.toast.showDetails = 'Zobrazit podrobnosti'
	dict.toast.hideDetails = 'Skrýt podrobnosti'

	dict.select.placeholder = 'Vyber'
	dict.select.search = 'Hledat'

	dict.datagrid.empty = 'Nic jsme nenašli.'
	dict.datagrid.filter = 'Filtr'
	dict.datagrid.exclude = 'Vyloučit'
	dict.datagrid.filters = 'Filtry'
	dict.datagrid.export = 'Export'
	dict.datagrid.layout = 'Zobrazení'
	dict.datagrid.showTable = 'Tabulka'
	dict.datagrid.showGrid = 'Dlaždice'
	dict.datagrid.visibleFields = 'Viditelné sloupce'
	dict.datagrid.na = '—'
	dict.datagrid.today = 'Dnes'
	dict.datagrid.textMatchMode.contains = 'obsahuje'
	dict.datagrid.textMatchMode.startsWith = 'začíná na'
	dict.datagrid.textMatchMode.endsWith = 'končí na'
	dict.datagrid.textMatchMode.equals = 'je přesně'
	dict.datagrid.textMatchMode.notContains = 'neobsahuje'
	dict.datagrid.textPlaceholder = 'Hledat'
	dict.datagrid.textReset = 'Zrušit'
	dict.datagrid.numberFrom = 'Od'
	dict.datagrid.numberTo = 'Do'
	dict.datagrid.dateStart = 'Od'
	dict.datagrid.dateEnd = 'Do'
	dict.datagrid.columnAsc = 'Vzestupně'
	dict.datagrid.columnDesc = 'Sestupně'
	dict.datagrid.columnHide = 'Skrýt'
	dict.datagrid.paginationFirstPage = 'První stránka'
	dict.datagrid.paginationPreviousPage = 'Předchozí stránka'
	dict.datagrid.paginationNextPage = 'Další stránka'
	dict.datagrid.paginationLastPage = 'Poslední stránka'
	dict.datagrid.paginationRowsPerPage = 'Řádků na stránku'
	dict.datagrid.pageInfo = 'Stránka ${page} z ${pagesCount}'
	dict.datagrid.pageInfoShort = 'Stránka ${page}'
	dict.datagrid.pageRowsCount = 'Řádků: ${totalCount}'
}
